import {DOM} from "./DOM";
import {getRandomString} from "./Random";

export namespace Modal {

    class Config {
        public static modalElementClass = 'customDesign-modals';
        public static hideModalClassName = "hide";
        public static modalCloseElementClass = "triggerModalClose";
        public static modalErrorElement = "customDesign-modals-content-error";
    }

    export class Helpers {

        /**
         * Get currently shown modal element
         * If not shown - return null
         */
        public static getShownModal() : HTMLDivElement|null {

            const modalElements = DOM.Parser.getHtmlElements(Config.modalElementClass, undefined, true);
            for (let i = 0; i < modalElements.length; i++) {
                const modal = modalElements[i] as HTMLDivElement;
                if (!modal.classList.contains(Config.hideModalClassName)) {
                    return modal;
                }
            }

            return null;
        }

        /**
         * Close modal using modal element reference
         * @param modalElement - modal element
         */
        public static closeModalByElement(modalElement: HTMLDivElement) : void {
            modalElement.classList.add(Config.hideModalClassName);
        }

        /**
         * Close modal by element ID
         * @param id - element ID
         */
        public static closeModalById(id: string) : void {
            this.closeModalByElement(DOM.Parser.getHtmlElement(id) as HTMLDivElement);
        }

        /**
         * Open modal using modal element reference
         * @param modalElement - modal element
         */
        public static openModalByElement(modalElement: HTMLDivElement) {
            modalElement.classList.remove(Config.hideModalClassName);

        }

        /**
         * Open modal by element ID
         * @param id - element ID
         */
        public static openModalById(id: string) {
            this.openModalByElement(DOM.Parser.getHtmlElement(id) as HTMLDivElement);
        }

        /**
         * Initialize modal triggers using modal element
         * @param modal - modal element
         * @param onClose - on modal close
         */
        public static initModalTriggersByModalElement(modal: HTMLDivElement, onClose?: (modal: HTMLElement) => void) : void {

            const modalError = DOM.Parser.getHtmlElementByClass(Config.modalErrorElement, modal);
            const randomString = getRandomString(5);
            modalError.classList.add(`selector-${randomString}`);
            modalError.dataset.selector = `selector-${randomString}`;

            DOM.Parser.getHtmlElementByClass(Config.modalCloseElementClass, modal).addEventListener('click', (event: MouseEvent) => {
                event.stopPropagation();
                event.preventDefault();
                if (onClose) { onClose(modal); }
                this.closeModalByElement(modal);
            });
        }

        /**
         * Initialize modal triggers using modal ID
         * @param modalId - modal ID
         * @param onClose - on modal close
         */
        public static initModalTriggersByModalId(modalId: string, onClose?: (modal: HTMLElement) => void) : void {
            this.initModalTriggersByModalElement(DOM.Parser.getHtmlElement(modalId) as HTMLDivElement, onClose);
        }
    }
}